import {Address} from "./address";

export class User {

  public id: string;
  public secretKey: string;
  public email: string;
  public firstName: string;
  public lastName: string;
  public phone: string;
  public phonePrefix: string;
  public emailVerified = false;
  public phoneVerified = false;
  public profileLevel: number;
  public infoVerificationStatus: null;
  public fs = 0;
  public address: Address = null;
  public gclid: string;
  public registrationStatus: number;
  public analyticsClientId: string;
  public language: string;

  public sendConfirmationEmail = false;
  public sendConfirmationText = false;


}

export enum UserInfoVerificationStatus {
  NON_STARTED = 0,
  IN_PROGRESS = 1,
  VERIFIED = 2,
  FAILED = 3,
  UNALLOWED_COUNTRY = 10,
  UNDERAGE = 11,
  UNABLE_TO_PROCESS = 12
}

export enum UserInfoRegistrationStatus {
  NON_STARTED = 0,
  BASIC = 1,
  FULL = 2,
}

export enum UserInfoVerifier {
  SILT = 1,
  NEOCHECK = 2,
  VERIFF = 3
}
